import Banner from '../components/Banner';
import Footer from '../components/Footer';
import ResetPasswordConfirm from '../components/ResetPasswordConfirm';
import '../styles/Login.css';

const ResetPasswordPage: React.FC = () => {
  return (
    <div className="page-container">
      <Banner />
      <main className="login-main">
        <ResetPasswordConfirm />
      </main>
      <Footer />
    </div>
  );
};

export default ResetPasswordPage;
